import { Validator } from './validator';

export class YourDataValidator implements Validator {
    public validate(): boolean {
        return true;
    }
}
